import { useState, useEffect } from "react";
import "./corporateOnboarding.css";
import Dropdown from "./dropdown"

const mealOptions = ["Breakfast", "Lunch", "Snacks", "Dinner"];
const dayOptions = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
const itemTypeOptions = ["Veg", "Non Veg", "Mixed"];

const ClientModal = ({ isOpen, onClose, getClients, type, clientData, handleClientData }) => {
  const [step, setStep] = useState(1);
  const [handlerName, setHandlerName] = useState("");
  const [handlerNumber, setHandlerNumber] = useState("");
  const [formData, setFormData] = useState({
    clientID: "",
    clientName: "",
    pocs: [{ name: "", phone: "" }],
    address: "",
  });
  const [selectedMeals, setSelectedMeals] = useState([]);
  const [mealDetails, setMealDetails] = useState({});
  const [clientDetails, setClientDetails] = useState(clientData);

  useEffect(() => {
    setClientDetails(clientData);
  },[clientData]);

  useEffect(() => {
    if (!isOpen) return;

    const getAdminDetails = JSON.parse(localStorage.getItem("AdminDetails"));
    if (getAdminDetails) {
      setHandlerName(getAdminDetails.userName);
      setHandlerNumber(getAdminDetails.userMobile);
    }

    if (type === "edit" && clientDetails) {
      setFormData({ ...clientDetails });
      setSelectedMeals(clientDetails.menuTypes || []);
      setMealDetails(clientDetails.servingDetails || {});
    } else {
      setFormData({
        clientID: "",
        clientName: "",
        pocs: [{ name: "", phone: "" }],
        address: "",
      });
      setSelectedMeals([]);
      setMealDetails({});
    }
    setStep(1);
  }, [isOpen, type, clientDetails]);

  const handlePOCChange = (index, field, value) => {
    const updatedPOCs = [...formData.pocs];
    updatedPOCs[index][field] = value;
    setFormData({ ...formData, pocs: updatedPOCs });
  };

  const handleToggle = (meal) => {
    setSelectedMeals((prev) =>
      prev.includes(meal) ? prev.filter((m) => m !== meal) : [...prev, meal]
    );
    setMealDetails((prev) => {
      const updated = { ...prev };
      if (!selectedMeals.includes(meal)) {
        updated[meal] = {
          servingDays: [],
          estimatedStrength: "",
          itemType: "",
          cuisine: "",
          price: "",
        };
      } else {
        delete updated[meal];
      }
      return updated;
    });
  };

  const handleMealDetailChange = (meal, field, value) => {
    setMealDetails((prev) => ({
      ...prev,
      [meal]: {
        ...prev[meal],
        [field]: value,
      },
    }));
  };

  const handleDelete = (meal) => {
    const confirmed = window.confirm(
      `Are you sure you want to remove "${meal}" from the selected meals?`
    );

    if (confirmed) {
      setSelectedMeals((prev) => prev.filter((m) => m !== meal));
      setMealDetails((prev) => {
        const updated = { ...prev };
        delete updated[meal];
        return updated;
      });
      setStep(2);
    }
  };

  const toggleServingDay = (meal, day) => {
    const current = mealDetails[meal]?.servingDays || [];
    const updated = current.includes(day)
      ? current.filter((d) => d !== day)
      : [...current, day];

    setMealDetails((prev) => ({
      ...prev,
      [meal]: {
        ...prev[meal],
        servingDays: updated,
      },
    }));
  };

  if (!isOpen) return null;

  const isNextDisabled = selectedMeals.some((meal) => {
    const details = mealDetails[meal] || {};
    return (
      !details.servingDays?.length ||
      !details.estimatedStrength ||
      !details.itemType ||
      !details.cuisine ||
      !details.price
    );
  });

  const handleSubmit = () => {
    let payload;
    let method = "post";

    if (type.toLowerCase() === "add" && formData.clientID) {
      console.log("Client already added with ID:", formData.clientID);
      onClose?.();
      getClients?.();
      return;
    }

    if (type.toLowerCase() === "add") {
      method = "post";
      payload = {
        ...formData,
        servingDetails: mealDetails,
        menuTypes: selectedMeals,
        handlerName,
        handlerNumber: handlerNumber,
      };
    } else {
      method = "put";
      payload = {
        ...formData,
        clientID: clientDetails?.clientID,
        createdTimeStamp: clientDetails?.createdTimeStamp,
        servingDetails: mealDetails,
        menuTypes: selectedMeals,
        handlerName,
        handlerNumber: handlerNumber,
      };
    }
    handleClientData(method, payload)
  };

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      role="dialog"
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {type === "edit" ? "Edit" : "Add"} Client
            </h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>

          <div className="modal-body overflow-auto" style={{ maxHeight: "70vh" }}>
            {step === 1 && (
              <div>
                <div className="form-group">
                  <label>Client Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.clientName}
                    onChange={(e) =>
                      setFormData({ ...formData, clientName: e.target.value })
                    }
                  />
                </div>
                {formData.pocs.map((poc, index) => (
                  <div className="form-row" key={index}>
                    <div className="form-group col">
                      <label>POC Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={poc.name}
                        onChange={(e) =>
                          handlePOCChange(index, "name", e.target.value)
                        }
                      />
                    </div>
                    <div className="form-group col">
                      <label>POC Phone</label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={10}
                        value={poc.phone}
                        onChange={(e) =>
                          handlePOCChange(index, "phone", e.target.value)
                        }
                      />
                    </div>
                  </div>
                ))}
                <button
                  className="btn btn-secondary btn-sm mb-4"
                  onClick={() =>
                    setFormData((prev) => ({
                      ...prev,
                      pocs: [...prev.pocs, { name: "", phone: "" }],
                    }))
                  }
                >
                  Add another POC
                </button>
                <div className="form-group">
                  <label>Delivery Address</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    value={formData.address}
                    onChange={(e) =>
                      setFormData({ ...formData, address: e.target.value })
                    }
                  ></textarea>
                </div>
              </div>
            )}
            {step === 2 && (
              <>
                <h5 className="mb-3">Requirements</h5>
                <div className="d-flex flex-wrap gap-2 border rounded p-3 mb-4">
                  {mealOptions.map((meal, index) => (
                    <button
                      key={index}
                      className={`btn btn-sm mx-1 ${
                        selectedMeals.includes(meal)
                          ? "btn-primary"
                          : "btn-outline-secondary"
                      }`}
                      onClick={() => handleToggle(meal)}
                    >
                      {meal}
                    </button>
                  ))}
                </div>
                {selectedMeals.length === 0 && (
                  <div className="text-danger mb-3">
                    Please select at least one meal type.
                  </div>
                )}
              </>
            )}
            {step === 3 && (
              <>
                <h5 className="mb-3">Serving Details</h5>

                {selectedMeals.map((meal) => {
                  const details = mealDetails[meal] || {};
                  const selectedDays = details.servingDays || [];

                  return (
                    <div key={meal} className="border rounded p-3 mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0">{meal}</h6>
                        {type.toLowerCase() === "edit" && (
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDelete(meal)}
                          >
                            Delete
                          </button>
                        )}
                      </div>

                      <div className="mb-3">
                        {dayOptions.map((day) => (
                          <button
                            key={day}
                            className={`btn btn-sm mx-1 mb-1 ${
                              selectedDays.includes(day)
                                ? "btn-success"
                                : "btn-outline-secondary"
                            }`}
                            onClick={() => toggleServingDay(meal, day)}
                          >
                            {day}
                          </button>
                        ))}
                      </div>

                      <div className="mb-3">
                        <label>Estimated Strength</label>
                        <input
                          type="number"
                          className="form-control"
                          value={details.estimatedStrength || ""}
                          onChange={(e) =>
                            handleMealDetailChange(
                              meal,
                              "estimatedStrength",
                              +e.target.value
                            )
                          }
                        />
                      </div>

                      <div className="row mb-3">
                        <div className="col">
                         <Dropdown
  label="Item Type"
  value={details.itemType}
  options={itemTypeOptions}
  onChange={(val) => handleMealDetailChange(meal, "itemType", val)}
/>



                        </div>
                        <div className="col">
                        <Dropdown
  label="Cuisine"
  value={details.cuisine}
  options={["North Indian", "South Indian", "Both"]}
  onChange={(val) => handleMealDetailChange(meal, "cuisine", val)}
/>
                        </div>
                      </div>

                      <div>
                        <label>Price (₹ / plate)</label>
                        <input
                          type="number"
                          className="form-control"
                          value={details.price || ""}
                          onChange={(e) =>
                            handleMealDetailChange(
                              meal,
                              "price",
                              +e.target.value
                            )
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setStep(step - 1)}
              disabled={step === 1}
            >
              Back
            </button>

            <button
              type="button"
              className="btn btn-primary"
              disabled={
                (step === 2 && selectedMeals.length === 0) ||
                (step === 3 && isNextDisabled)
              }
              onClick={() => {
                if (step === 3) {
                  handleSubmit();
                } else {
                  setStep(step + 1);
                }
              }}
            >
              {step === 3
                ? type.toLowerCase() === "edit"
                  ? "Submit"
                  : "Next"
                : "Next"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientModal;
